<template lang="pug">
.product-slot(:class="{'confirmed': confirmed}")
  .banner
    img(:src="product.thumb")
  .copy
    .name {{product.name}}
    .price ¥{{product.price}}
  
</template>
<script>
export default {
  name: 'ProductSlot',
  props: {
    product: {},
    confirmed: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.product-slot
  transition: all $card-trans
  display: flex
  flex-direction: row
  align-items: center
  justify-content: center
  &.confirmed
    .banner
      width: 161px
      height: 161px
  .banner
    transition: all $card-trans
    width: 170px
    height: 170px
    border-radius: 5px
    //background: #168BFF
    line-height: 0
    position: relative
    img
      width: 100%
      object-fit: cover
  .copy
    height: 156px
    padding: 0 38px
    color: black
    .name
      //background: #168BFF
      font-size: 28px
      line-height: 28px
      letter-spacing: 0
    .price
      //background: #3a602e
      font-size: 44px
      line-height: 44px
      margin-top: 33px
</style>
